import { api } from '../api.js';
import { subscribe } from '../state.js';
import { navigate } from '../router.js';
import { getTranslatedFields, translate } from '../lib/i18n.js';
import type { ApiConceptListItem } from '../../shared/types.js';

interface FlowListItem extends ApiConceptListItem {
  stepCount: number;
}

export async function renderFlowsListView(container: HTMLElement): Promise<void | (() => void)> {
  container.innerHTML = `<div class="loading">${translate('common.loading', 'loading...')}</div>`;
  let langUnsub: (() => void) | null = null;

  try {
    const flows = await api.getFlowList() as FlowListItem[];

    function render(): void {
      container.innerHTML = '';
      const view = document.createElement('div');
      view.className = 'view view--flows';

      // Header
      const header = document.createElement('div');
      header.className = 'view__header';
      header.innerHTML = `
        <h1 class="view__title">${translate('flows.title', 'Flows')}</h1>
        <p class="view__subtitle">${translate('flows.subtitle', 'Procedures and processes in the knowledge network.')}</p>
      `;
      view.appendChild(header);

      if (flows.length === 0) {
        const empty = document.createElement('div');
        empty.className = 'not-found';
        empty.style.minHeight = '30vh';
        empty.innerHTML = `<p class="not-found__message">${translate('flows.empty', 'No flows defined yet.')}</p>`;
        view.appendChild(empty);
        container.appendChild(view);
        return;
      }

      // Flows grid
      const list = document.createElement('div');
      list.className = 'flows-list';

      for (const flow of flows) {
        const { title, summary } = getTranslatedFields(flow);

        const card = document.createElement('div');
        card.className = 'flows-item';
        card.innerHTML = `
          <div class="flows-item__header">
            <h3 class="flows-item__title">${title}</h3>
            <span class="flows-item__count">${flow.stepCount} ${flow.stepCount === 1 ? translate('flows.step', 'step') : translate('flows.steps', 'steps')}</span>
          </div>
          ${summary ? `<p class="flows-item__summary">${summary}</p>` : ''}
        `;
        card.addEventListener('click', () => navigate(`/flow/${flow.slug}`));
        list.appendChild(card);
      }

      view.appendChild(list);
      container.appendChild(view);
    }

    render();
    langUnsub = subscribe('lang', render);

    return () => { if (langUnsub) langUnsub(); };
  } catch (err) {
    container.innerHTML = `<div class="view"><p class="form-error">${translate('flows.error', 'Failed to load flows')}: ${(err as Error).message}</p></div>`;
    return () => { if (langUnsub) langUnsub(); };
  }
}
